import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSuperAdminSingleSuscrip } from "../../../context/SuperAdmin/SingleSuscriptContext";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import { ProfileRowUserSuscription } from "./ProfileRowUserSuscription";
import { useMemo } from "react";

const UserSuscriptionsTable = () => {
  const {
    suscribedUsers,
    setSelectedSuscribedUsers,
    selectedSuscribedUsers,
    searchText,
  } = useSuperAdminSingleSuscrip();

  const selectAll = () => {
    setSelectedSuscribedUsers(filteredUsers.map((user) => user.id_usuario));
  };

  // Manejar selección/deselección de un permiso
  const handleSelect = (id: string) => {
    setSelectedSuscribedUsers((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Filtro de usuarios por búsqueda
  const filteredUsers = useMemo(() => {
    const normalizedSearch = searchText.toLowerCase().trim();
    return suscribedUsers.filter(
      (u) =>
        `${u.nombres} ${u.apellidos}`
          .toLowerCase()
          .includes(normalizedSearch) ||
        u.email.toLowerCase().includes(normalizedSearch)
    );
  }, [suscribedUsers, searchText]);

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedSuscribedUsers.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedSuscribedUsers([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Apellido
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Email
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Fecha de asignación
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Créditos gastados
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Estado
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredUsers.length > 0 ? (
            filteredUsers.map((usuario, index) => (
              <ProfileRowUserSuscription
                usuario={usuario}
                i={index + 1}
                key={usuario.id_usuario}
                handleSelect={handleSelect}
                isSelected={selectedSuscribedUsers.includes(usuario.id_usuario)}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserSuscriptionsTable;
